import React, { Fragment } from "react";
import styled from "styled-components";
import ContentCopy from "@material-ui/icons/ContentCopy";

import SecondaryButton from "./SecondaryButton";

const DuplicateButton = ({ onClick, ...other }) => (
  <SecondaryButton onClick={onClick} {...other}>
    <ContentCopy />
    DUPLICATE
  </SecondaryButton>
);
export default DuplicateButton;
